import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesReorderControllerModule } from './controllers/TemplatesReorderController';

export const TemplatesReorderView = angular
  .module('acme.view.application.templates.reorder', [
    uiRouter,
    'ui.bootstrap',
    TemplatesReorderControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    $stateProvider.state({
      name: 'application.templates.reorder',
      url: '/reorder',
      views: {
        'subview-main': {
          controller: 'TemplatesReorderController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/reorder/reorder.tpl.html',
        },
      },
      data: {
        pageTitle: 'Reorder Event Templates',
        /** Secure With Permissions **/
        permissions: ['EVENT_TEMPLATE_REORDER'],
      },
    });
  }).name;
